import { inject, makeEnvironmentProviders, provideAppInitializer, type EnvironmentProviders } from '@angular/core';
import { ConsentService } from './consent.service';

/** Re-applies a persisted analytics opt-out after gtag has loaded. Register AFTER provideAnalytics(). */
export function provideConsent(): EnvironmentProviders {
  return makeEnvironmentProviders([provideAppInitializer(() => inject(ConsentService).applyPersisted())]);
}
